import { generateReducer } from 'redux-dryer';
import Actions from './actions';

const initialState = {
  companyName: '',
  currentSection: '',
} as const;

export default generateReducer(initialState, Actions);
